import { Col, Flex, Row } from 'antd'
import dayjs from 'dayjs'

import { InvestigationTestEnrichedDto } from 'src/api/requests'
import { Text } from 'src/components'
import { getFullName } from 'src/features/users/utils'
import { dayMonthYearHourMinutesFormatWithDot } from 'src/libs'
import { useLocales } from 'src/locales'

type Props = {
  test: InvestigationTestEnrichedDto
}

export const TestDetailsFields = ({ test }: Props) => {
  const { t, currentLang } = useLocales()

  const formatDate = (date?: string | null) =>
    date
      ? dayjs.utc(date).tz().format(dayMonthYearHourMinutesFormatWithDot)
      : '-'

  return (
    <Row gutter={[24, 24]}>
      <Col span={8}>
        <Flex vertical gap={8}>
          <Text>{t('tests_results.type')}</Text>

          <Text weight={400}>
            {test.type?.translation?.[currentLang.value]}
          </Text>
        </Flex>
      </Col>

      <Col span={8}>
        <Flex vertical gap={8}>
          <Text>{t('consultations.harvest_date')}</Text>
          <Text weight={400}>{formatDate(test.testingAt)}</Text>
        </Flex>
      </Col>

      {test.approvedAt && (
        <Col span={8}>
          <Flex vertical gap={8}>
            <Text>{t('investigations.approved_date')}</Text>
            <Text weight={400}>{formatDate(test?.approvedAt)}</Text>
          </Flex>
        </Col>
      )}

      {test.approvedBy && (
        <>
          <Col span={8}>
            <Flex vertical gap={8}>
              <Text>{t('investigations.approved_by')}</Text>
              <Text weight={400}>
                {getFullName(
                  test.approvedBy?.firstName,
                  test.approvedBy?.lastName
                )}
              </Text>
            </Flex>
          </Col>

          {test.approvedBy?.institution?.name && (
            <Col span={8}>
              <Flex vertical gap={8}>
                <Text>{t('common.medical_institution')}</Text>
                <Text weight={400}>{test.approvedBy.institution.name}</Text>
              </Flex>
            </Col>
          )}
        </>
      )}
    </Row>
  )
}
